import { render } from "./RegisterPayment.vue?vue&type=template&id=e1db19da"
import script from "./RegisterPayment.vue?vue&type=script&lang=js"
export * from "./RegisterPayment.vue?vue&type=script&lang=js"
script.render = render

export default script